module.exports = __webpack_public_path__ + "static/grupopremier-f5f3310bfa87401b264676adf7236f56.png";